<!-- 共享表单字段：直接编辑父组件传入的 form 对象（父组件持有 el-form 及校验） -->
<!-- eslint-disable vue/no-mutating-props -->
<template>
    <el-form-item label="套餐名称" prop="name">
        <el-input v-model.trim="form.name" maxlength="100" show-word-limit></el-input>
    </el-form-item>
    <el-form-item label="服务时长" prop="service_time">
        <div class="duration-row">
            <el-input-number v-model="form.service_time" :min="1" :precision="0"></el-input-number>
            <el-select v-model="form.service_time_unit" placeholder="单位">
                <el-option v-for="unit in timeUnits" :key="unit" :label="unit" :value="unit"></el-option>
            </el-select>
        </div>
    </el-form-item>
    <el-form-item label="扣款周期数">
        <el-input-number v-model="form.cycles" :min="0" :precision="0"></el-input-number>
        <span class="help-text">0 表示无限扣款（持续自动续费），N 表示扣 N 期后结束</span>
    </el-form-item>
    <el-form-item label="云文件保留天数">
        <el-input-number v-model="form.file_time" :min="0" :precision="0"></el-input-number>
        <span class="help-text">无摄像头套餐填 0</span>
    </el-form-item>
    <el-form-item label="免费试用天数" prop="trial_days">
        <el-input-number v-model="form.trial_days" :min="0" :max="trialDaysMax" :precision="0"></el-input-number>
        <span class="help-text">0 表示不支持试用；上限 {{ trialDaysMax }} 天。用户首次订阅且有资格时首期不扣款，试用期满自动按套餐价扣第一笔。修改只影响之后的新订阅。</span>
    </el-form-item>
    <el-form-item label="套餐等级">
        <el-input-number v-model="form.level" :min="0" :precision="0"></el-input-number>
        <span class="help-text">用于档位比较</span>
    </el-form-item>
    <el-form-item label="标签">
        <el-select v-model="form.tag">
            <el-option v-for="item in tagOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
    </el-form-item>
    <el-form-item label="排序权重">
        <el-input-number v-model="form.sort_order" :min="0" :precision="0"></el-input-number>
        <span class="help-text">数字越小越靠前</span>
    </el-form-item>
    <el-form-item label="套餐说明">
        <el-input v-model="form.explain" type="textarea" :rows="3" maxlength="500" show-word-limit></el-input>
    </el-form-item>
</template>

<script>
import { TIME_UNITS, TAG_OPTIONS, TRIAL_DAYS_MAX } from './constants'

export default {
    name: 'PetBaseInfoFields',
    props: {
        form: { type: Object, required: true }
    },
    data() {
        return { timeUnits: TIME_UNITS, tagOptions: TAG_OPTIONS, trialDaysMax: TRIAL_DAYS_MAX }
    }
}
</script>

<style scoped>
.duration-row { display: flex; gap: 10px; align-items: center; }
.duration-row .el-select { width: 150px; }
.help-text { margin-left: 10px; color: #909399; font-size: 12px; }
</style>
